<template>
  <hm-content title="我的活动" ref="hmcontent">
    <div class="table-panel flex flex-end">
      <div>
        <el-dialog title="其它活动" :visible.sync="otherActivityWindow" width="30%" @close="clearSelect">
          <div class="flex flex-start">
            <el-button type="primary" class="mr10" @click="skip('EventList')">预约活动</el-button>
            <el-button type="primary" class="mr10" @click="skip('SignInActivity')">签到活动</el-button>
            <el-button type="primary" class="mr10" @click="skip('JieLongActivite')">接龙活动</el-button>
            <el-button type="primary" @click="skip('SweepstakesList')">线下抽奖</el-button>
          </div>
        </el-dialog>
        <el-select
            clearable
            class="mr10"
            size="small"
            v-model="enabledState"
            placeholder="请选择活动状态"
        >
          <el-option label="上线" value="yes"></el-option>
          <el-option label="下线" value="no"></el-option>
        </el-select>
        <el-select
            clearable
            class="mr10"
            size="small"
            filterable
            v-model="gameType"
            visible-change="otherActivity"
            placeholder="请选择活动类型"
            @change="otherActivity"
        >
          <el-option
              :label="v.gameName"
              :value="v.gameCode"
              :key="i"
              v-for="(v, i) in gameTypeList"
          ></el-option>
        </el-select>
        <el-input
            clearable
            style="width: 250px"
            v-model.trim="keyword"
            placeholder="请输入活动名称/编号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
            type="success"
            size="small"
            @click="helpCouponOutput"
            :loading="isOutputing"
        >导出</el-button
        >
        <el-button type="info" size="small" @click="reset">重置</el-button>
      </div>
    </div>
    <div class="table">
      <div class="flex flex-between item-center">
        <div class="hm-radio-group">
          <el-radio-group v-model="dateFlag" size="small" @change="switchTab">
            <el-radio-button label="0"
            >全部({{ myActivityList.stateCount.totalCount }})</el-radio-button
            >
            <el-radio-button label="2">
              进行中({{ myActivityList.stateCount.ongoingCount }})
            </el-radio-button>
            <el-radio-button label="1">
              未开始({{ myActivityList.stateCount.notStartCount }})
            </el-radio-button>
            <el-radio-button label="3"
            >已结束({{ myActivityList.stateCount.endCount }})</el-radio-button
            >
          </el-radio-group>
        </div>
      </div>
      <el-table
          :data="myActivityList.pageList.records"
          style="width: 100%"
          stripe
          border
          size="small"
      >
        <!-- <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>-->
        <el-table-column
            header-align="center"
            align="center"
            label="活动编号"
            width="180"
            prop="gameCode"
        >
          <template slot-scope="scope">
            <div class="table-status flex item-center">
              <span
                  class="status success-bg"
                  v-show="scope.row.dateFlag == '2'"
              ></span>
              <span
                  class="status gray-bg"
                  v-show="scope.row.dateFlag == '1'"
              ></span>
              <span
                  class="status danger-bg"
                  v-show="scope.row.dateFlag == '3'"
              ></span>
              <span class="flex flex-1 flex-center">
                {{ scope.row.gameCode }}
              </span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="gameType"
            label="活动类型"
            width="180"
        >
          <template slot-scope="scope">
            <span v-if="scope.row.gameType == 'turntable'">大转盘</span>
            <span v-else-if="scope.row.gameType == 'seckill'">秒杀</span>
            <span v-else-if="scope.row.gameType == 'bargain'">砍价</span>
            <span v-else-if="scope.row.gameType == 'bargains_team'"
            >特价团
              <span v-if="scope.row.groupTeamType==='numberTeam'">(数量团)</span>
              <span v-else>(人数团)</span>
            </span>
            <span v-else-if="scope.row.gameType == 'lottery_team'">抽奖团</span>
            <span v-else-if="scope.row.gameType == 'collect_card'">集卡</span>
            <span v-else-if="scope.row.gameType == 'leader_free_team'"
            >团长免单团</span
            >
            <span v-else-if="scope.row.gameType == 'integral_exchange'"
            >积分兑换</span
            >
            <span v-else-if="scope.row.gameType == 'single_single_exclusive'"
            >单人单次专享活动</span
            >
            <span v-else-if="scope.row.gameType == 'lucky_charm'"
            >锦鲤活动</span
            >
            <span v-else-if="scope.row.gameType == 'combination_set'"
            >组合套餐活动</span
            >
            <span v-else-if="scope.row.gameType == 'help_coupon'"
            >助力劵</span
            >
            <span v-else-if="scope.row.gameType == 'save_money_card'"
            >省钱卡</span
            >
            <span v-else-if="scope.row.gameType == 'password'"
            >口令红包</span
            >
            <span v-else-if="scope.row.gameType == 'red_envelope_rain'"
            >红包雨</span
            >
            <span v-else-if="scope.row.gameType == 'jielong'"
            >接龙活动</span
            >
            <span v-else-if="scope.row.gameType == 'fission_person'"
            >客户裂变</span
            >
            <span v-else-if="scope.row.gameType == 'fission_group'"
            >群裂变</span
            >
            <span v-else-if="scope.row.gameType == 'timed_draw'"
            >定时抽奖</span
            >
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="gameName"
            label="活动名称"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="createTime"
            label="活动创建时间"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="enabledState"
            label="活动状态"
        >
          <template slot-scope="scope">
            <span class="success" v-show="scope.row.enabledState === 'yes'"
            >上线</span
            >
            <span class="danger" v-show="scope.row.enabledState === 'no'"
            >下线</span
            >
          </template>
        </el-table-column>
        <el-table-column
            width="280"
            label="操作"
            header-align="center"
            align="left"
        >
          <template slot-scope="scope">
            <div class="">
              <!-- <el-button
                type="text"
                class="pointer mr10 no-bg"
                @click="viewCardCode(scope.row)"
                v-if="
                  scope.row.gameType === 'collect_card' &&
                    scope.row.getCardMode === 'scan'
                "
              >
                卡片码
              </el-button>
              <el-button
                type="text"
                class="pointer mr10 no-bg"
                @click="toGetAwardsList('collect_card', scope.row.gameId)"
              >
                中奖名单
              </el-button> -->
              <el-tooltip
                  class="item"
                  v-if="scope.row.gameType == 'turntable'"
                  content="参与活动记录"
                  placement="top"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="toReservitionList(scope.row)"
                >
                  <span class="hmicon icon-chazhaobiaodanliebiao blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  v-if="scope.row.gameType == 'red_envelope_rain'"
                  content="参与活动记录"
                  placement="top"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="toReservitionList2(scope.row)"
                >
                  <span class="hmicon icon-chazhaobiaodanliebiao blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  v-if="scope.row.gameType == 'fission_person' || scope.row.gameType == 'fission_group'"
                  content="参与活动记录"
                  placement="top"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="toReservitionList3(scope.row)"
                >
                  <span class="hmicon icon-chazhaobiaodanliebiao blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="卡片码"
                  placement="top"
                  v-if="
                  scope.row.gameType === 'collect_card' &&
                    scope.row.getCardMode === 'scan'
                "
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="viewCardCode(scope.row)"
                >
                  <span class="hmicon icon-kapianerweima blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="中奖名单"
                  placement="top"
                  v-if="scope.row.gameType === 'collect_card'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="toGetAwardsList('collect_card', scope.row.gameId)"
                >
                  <span class="hmicon icon-zhongjiangmingdan blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="查看"
                  placement="top"
                  v-if="scope.row.gameType !== 'collect_card' && scope.row.gameType !== 'jielong'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="toDetails(scope.row)"
                >
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="参与详情"
                  placement="top"
                  v-if="scope.row.gameType === 'lucky_charm' "
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="participate(scope.row)"
                >
                  <span class="hmicon icon-baobiao blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="参与详情"
                  placement="top"
                  v-if="scope.row.gameType === 'timed_draw' "
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="participate1(scope.row)"
                >
                  <span class="hmicon icon-baobiao blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="活动二维码" placement="top" v-if="scope.row.gameType !== 'jielong'">
                <button
                    class="pointer mr10 no-bg"
                    @click="productQrcode(scope.row)"
                >
                  <span class="hmicon icon-erweima blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip class="item" content="复制" placement="top" v-show="gameType != 'save_money_card' && scope.row.gameType !== 'jielong'"  >
                <button  class="pointer mr10 no-bg" @click="copy(scope.row)">
                  <span class="hmicon icon-fuzhi blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="上线"
                  placement="top"
                  v-if="scope.row.enabledState === 'no' && scope.row.gameType !== 'jielong'"
              >
                <button
                    v-if="
                    scope.row.updateMode === 'yes' &&
                      scope.row.enabledState === 'no'
                  "
                    class="pointer mr10 no-bg"
                    @click="shangxian(scope.row)"
                >
                  <span class="hmicon icon-shangxian blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="下线"
                  placement="top"
                  v-show="scope.row.enabledState !== 'no' && scope.row.gameType !== 'jielong'"
              >
                <button class="pointer mr10 no-bg" @click="xiaxian(scope.row)">
                  <span class="hmicon icon-xiaxian blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="编辑"
                  placement="top"
                  v-if="
                  scope.row.gameType === 'single_single_exclusive' ||
                  (scope.row.updateMode === 'yes' &&
                  scope.row.gameType !== 'collect_card' && 
                  scope.row.gameType !== 'jielong')
                "
              >

                <button class="pointer mr10 no-bg" @click="edit(scope.row)">
                  <span class="hmicon icon-bianji blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="砍价明细"
                  placement="top"
                  v-if="scope.row.gameType == 'bargain'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="bargainDetail(scope.row)"
                >
                  <span class="hmicon icon-kanjiahuodong blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="兑换明细"
                  placement="top"
                  v-if="scope.row.gameType == 'bargain' && scope.row.bargainByOrderState == 'yes'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="exchangeDetail(scope.row)"
                >
                  <span class="hmicon icon-zhongjiangmingdan blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="省钱卡明细"
                  placement="top"
                  v-if="scope.row.gameType == 'save_money_card'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="save_money_card(scope.row)"
                >
                  <span class="hmicon icon-kanjiahuodong blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="口令红包明细"
                  placement="top"
                  v-if="scope.row.gameType == 'password'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="password_red_envelope(scope.row)"
                >
                  <span class="hmicon icon-kanjiahuodong blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="助力明细"
                  placement="top"
                  v-if="scope.row.gameType == 'help_coupon'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="helpingDetail(scope.row)"
                >
                  <span class="hmicon icon-kanjiahuodong blue"></span>
                </button>
              </el-tooltip>
              <el-tooltip
                  class="item"
                  content="查看"
                  placement="top"
                  v-if="scope.row.gameType === 'jielong'"
              >
                <button
                    class="pointer mr10 no-bg"
                    @click="skip('JieLongActivite')"
                >
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <hm-status />
    </div>
    <div class="hm-pagination">
      <el-pagination
          background
          :total="myActivityList.pageList.total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
      ></el-pagination>
    </div>
    <el-dialog
        :close-on-click-modal="false"
        title="参与详情"
        width="1200px"
        :visible.sync="dialogVisible"
        :before-close="handleClose"
    >
      <el-dialog
          width="800px"
          title="手动开奖"
          :visible.sync="innerVisible"
          append-to-body
      >
        <el-form
            :model="ruleForm"
            :rules="rules"
            ref="ruleForm"
            label-width="130px"
        >
          <el-form-item label="手动开奖人数" prop="joinNumber">
            <el-input
                maxlength="25"
                style="width: 400px"
                size="small"
                clearable
                class="mr10 ipt"
                v-model.trim="ruleForm.joinNumber"
                placeholder="请输入手动开奖人数"
            ></el-input>
            <div class="form-item-tip">请输入大于0的正整数</div>
            <div class="form-item-tip">手动开奖说明：</div>
            <div class="form-item-tip">
              1.现场活动，自动开奖后中奖的会员不在现场，可重新手动开奖 操作
              <br />
              2.还没到自动开奖时间
              <br />
              3.操作方法就是，已出中奖名单后，点击重置按钮，然后点手动开奖按钮重新抽奖
              <br />
            </div>
          </el-form-item>
        </el-form>

        <span
            slot="footer"
            class="dialog-footer flex flex-center"
            v-if="participateType === 'winning'"
        >
          <el-button
              @click="submitForm('ruleForm')"
              size="small"
              type="primary"
              class="mr10"
          >
            确认开奖</el-button
          >
          <el-popover
              placement="top-start"
              width="300"
              trigger="hover"
              content="重置后手机端恢复抽奖页面，可继续开奖."
          >
            <el-button
                slot="reference"
                @click="innerVisible = false"
                size="small"
                type="info"
            >
              取 消</el-button
            >
          </el-popover>
        </span>
      </el-dialog>
      <div class="mb10">
        <el-radio-group
            v-model="participateType"
            size="small"
            @change="switchTabPar"
        >
          <el-radio-button label="participate">参与列表</el-radio-button>
          <el-radio-button label="winning">中奖名单</el-radio-button>
        </el-radio-group>
      </div>
      <div>
        <div
            class="flex item-center mb10"
            :class="
            participateType === 'participate' ? 'flex-between' : 'flex-end'
          "
        >
          <div class="flex flex-end" v-if="participateType === 'participate' && styleType!=='normal'">
            <div @click="outputExcel" class="delete mr20 pointer">
              <span class="delete-icon hmicon icon-daochu"></span>
              导出模板
            </div>
            <div class="delete mr20 pointer open-file">
              <span class="delete-icon hmicon icon-daoru"></span>
              导入参与名单
              <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
          </div>
          <div v-if="styleType==='normal'"></div>
          <div>
            <el-input
                clearable
                style="width: 250px"
                v-model.trim="searchCondition.keyWords"
                placeholder="请输入参与者手机号/姓名"
                size="small"
                class="ipt mr10"
            ></el-input>
            <el-select
                size="small"
                clearable
                class="mr10"
                placeholder="请选择参与类型"
                v-model="searchCondition.joinType"
                v-if="styleType!=='normal'"
            >
              <el-option label="报名参加" value="apply"> </el-option>
              <el-option label="导表参加" value="import"> </el-option>
            </el-select>
            <el-select
                v-if="participateType === 'participate'"
                size="small"
                clearable
                class="mr10"
                placeholder="是否候选人身份"
                v-model="searchCondition.isDefaultWinner"
            >
              <el-option label="是" value="yes"> </el-option>
              <el-option label="否" value="no"> </el-option>
            </el-select>
            <el-select
                v-if="participateType === 'winning'"
                size="small"
                clearable
                class="mr10"
                placeholder="请选择中奖形式"
                v-model="searchCondition.winningType"
            >
              <el-option label="自动开奖" value="auto"> </el-option>
              <el-option label="手动开奖" value="manual"> </el-option>
            </el-select>
            <el-button type="primary" size="small" @click="searchPart"
            >查询</el-button
            >
            <el-button
                v-if="participateType === 'participate'"
                type="success"
                size="small"
                @click="outputPart('queryPartAllList', '参与列表', 'tablePart')"
                :loading="isOutputing"
            >导出</el-button
            >
            <el-button
                v-else
                type="success"
                size="small"
                @click="
                outputPart('queryLuckyWinnerAllList', '中奖名单', 'tablePart')
              "
                :loading="isOutputing"
            >导出</el-button
            >
          </div>
        </div>
        <div>
          <div class="flex flex-end" v-if="participateType === 'participate'">
            <div class="delete mr20 pointer open-file" slot="reference">
              <span class="delete-icon hmicon icon-daoru"></span>
              批量导入更改候选人身份
              <input
                  type="file"
                  @change="importf"
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
              />
            </div>
            <!-- <el-popover placement="top" width="160" v-model="visible">
              <p class="flex flex-center">批量导入修改候选人身份</p>

              <div class="flex flex-center">
                <el-button
                  type="text"
                  size="small"
                  class="gray"
                  @click="batchSetting('no')"
                  >撤销身份</el-button
                >
                <el-button type="text" size="small" @click="batchSetting('yes')"
                  >绑定身份</el-button
                >
              </div>
              <div slot="reference" class="pointer">
                <span class="delete-icon hmicon icon-xitong"></span>
                批量设置身份
              </div>
            </el-popover> -->
          </div>
          <el-table
              v-if="participateType === 'participate'"
              :data="participateList"
              @selection-change="getChecked"
              style="width: 100%"
              stripe
              border
              height="500"
              ref="tablePart"
              size="small"
          >
            <el-table-column type="selection" key="selection"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                key="joinId"
                :index="index => index + (currentPagePart - 1) * 10 + 1"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="活动名称"
                prop="gameName"
                key="gameName"
            ></el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                label="参与时间"
                prop="joinTime"
                key="joinTime"
            ></el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                label="参与类型"
                prop="joinType"
                key="joinType"
                v-if="styleType!=='normal'"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.joinType === 'import'">导表参加</div>
                <div v-else>报名参加</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="姓名/电话"
                prop="memberInfo"
                key="memberInfo"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.memberName }}/ {{ scope.row.memberMobile }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="个人助力值"
                prop="memberHelpValue"
                key="memberHelpValue"
                v-if="styleType === 'virtualize'"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="是否候选人身份"
                prop="isDefaultWinner"
                key="isDefaultWinner"
            >
              <template slot-scope="scope">
                <!-- <div
                  :class="
                    scope.row.isDefaultWinner === 'yes' ? 'success' : 'gary'
                  "
                >
                  {{ scope.row.isDefaultWinner === "yes" ? "是" : "否" }}
                </div> -->
                <el-switch
                    @change="isDefaultWinnerChange(scope.row)"
                    v-model="scope.row.isDefaultWinner"
                    size="mini"
                    active-color="#13ce66"
                    inactive-color="#ff4949"
                    active-value="yes"
                    active-text="是"
                    inactive-text="否"
                    inactive-value="no"
                >
                </el-switch>
              </template>
            </el-table-column>
          </el-table>
          <el-table
              v-else
              :data="participateList"
              style="width: 100%"
              stripe
              border
              height="500"
              ref="tablePart"
              size="small"
          >
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                key="joinId"
                :index="index => index + (currentPagePart - 1) * 10 + 1"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="活动名称"
                prop="gameName"
                key="gameName"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="开奖时间"
                prop="createTime"
                key="createTime"
            ></el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                label="参与类型"
                prop="joinType"
                key="joinType"
                v-if="styleType!=='normal'"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.joinType === 'import'">导表参加</div>
                <div v-else>报名参加</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="姓名/电话"
                prop="memberInfo"
                key="memberInfo"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.memberName }}/ {{ scope.row.memberMobile }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="个人助力值"
                prop="memberHelpValue"
                key="memberHelpValue"
                v-if="styleType === 'virtualize'"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="中奖形式"
                prop="winningType"
                key="winningType"
            >
              <template slot-scope="scope">
                <div
                    v-if="scope.row.winningType === 'manual'"
                    style="color: #ff7f10"
                >
                  手动开奖
                </div>
                <div v-else style="color: #2fc348">自动开奖</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="是否核销"
                prop="sendState"
                key="sendState"
            >
              <template slot-scope="scope">
                <div
                    v-if="scope.row.sendState === '未发放'"
                    style="color: #ff7f10"
                >
                  <el-button
                      type="text"
                      size="small"
                      @click="verification(scope.row)"
                  >核销</el-button
                  >
                </div>
                <div v-else>
                  <el-button type="text" size="small" disabled
                  >已核销</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
                background
                :total="total"
                @size-change="handleSizeChangePart"
                @current-change="pagingPart"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPagePart"
            ></el-pagination>
          </div>
        </div>
      </div>
      <span
          slot="footer"
          class="dialog-footer flex flex-center"
          v-if="participateType === 'winning'"
      >
        <el-button
            size="small"
            type="primary"
            class="mr10"
            @click="manualOpen"
            style="background: #ff7f10; border-color: #ff7f10"
        >
          手动开奖</el-button
        >
        <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="重置后手机端恢复抽奖页面，可继续开奖."
        >
          <el-button slot="reference" @click="restLc" size="small" type="info">
            重置</el-button
          >
        </el-popover>
      </span>
    </el-dialog>
    
    <el-dialog
        :close-on-click-modal="false"
        title="参与详情"
        width="1200px"
        :visible.sync="dialogVisible1"
        :before-close="handleClose5"
    >
      <div class="mb10">
        <el-radio-group
            v-model="participateType1"
            size="small"
            @change="switchTabPar1"
        >
          <el-radio-button label="participate">参与列表</el-radio-button>
          <el-radio-button label="winning">中奖名单</el-radio-button>
        </el-radio-group>
          <div style="display: inline-block;right: 20px;position: absolute;">
            <el-input
                clearable
                style="width: 250px"
                v-model.trim="searchCondition.keyWords"
                placeholder="请输入参与者手机号/姓名"
                size="small"
                class="ipt mr10"
            ></el-input>
            <el-button type="primary" size="small" @click="searchPart1"
            >查询</el-button
            >
            <el-button
                v-if="participateType1 === 'participate'"
                type="success"
                size="small"
                @click="outputPart1('queryPartAllList1', '参与列表', 'tablePart')"
                :loading="isOutputing"
            >导出</el-button
            >
            <el-button
                v-else
                type="success"
                size="small"
                @click="
                outputPart1('queryLuckyWinnerList1', '中奖名单', 'tablePart')
              "
                :loading="isOutputing"
            >导出</el-button
            >
          </div>
      </div>
      <div>
        
        <div>
          <el-table
              v-if="participateType1 === 'participate'"
              :data="participateList"
              @selection-change="getChecked"
              style="width: 100%"
              stripe
              border
              height="500"
              ref="tablePart"
              size="small"
          >
            <el-table-column type="selection" key="selection"></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                key="joinId"
                :index="index => index + (currentPagePart - 1) * 10 + 1"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="活动名称"
                prop="gameName"
                key="gameName"
            ></el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                label="参与时间"
                prop="joinTime"
                key="joinTime"
            ></el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                label="参与类型"
                prop="joinType"
                key="joinType"
                v-if="styleType!=='normal'"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.joinType === 'import'">导表参加</div>
                <div v-else>报名参加</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="姓名/电话"
                prop="memberInfo"
                key="memberInfo"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.memberName }}/ {{ scope.row.memberMobile }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="个人助力值"
                prop="memberHelpValue"
                key="memberHelpValue"
                v-if="styleType === 'virtualize'"
            >
            </el-table-column>
          </el-table>
          <el-table
              v-else
              :data="participateList"
              style="width: 100%"
              stripe
              border
              height="500"
              ref="tablePart"
              size="small"
          >
            <el-table-column
                header-align="center"
                align="center"
                type="index"
                label="序号"
                width="50"
                key="joinId"
                :index="index => index + (currentPagePart - 1) * 10 + 1"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="活动名称"
                prop="gameName"
                key="gameName"
            ></el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="开奖时间"
                prop="winningTime"
                key="winningTime"
            ></el-table-column>

            <el-table-column
                header-align="center"
                align="center"
                label="参与类型"
                prop="joinType"
                key="joinType"
                v-if="styleType!=='normal'"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.joinType === 'import'">导表参加</div>
                <div v-else>报名参加</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="姓名/电话"
                prop="memberInfo"
                key="memberInfo"
            >
              <template slot-scope="scope">
                <div>
                  {{ scope.row.memberName }}/ {{ scope.row.memberMobile }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="个人助力值"
                prop="memberHelpValue"
                key="memberHelpValue"
                v-if="styleType === 'virtualize'"
            >
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="中奖形式"
                prop="winningType"
                key="winningType"
            >
              <template slot-scope="scope">
                <div
                    v-if="scope.row.winningType === 'manual'"
                    style="color: #ff7f10"
                >
                  手动开奖
                </div>
                <div v-else style="color: #2fc348">定时自动开奖</div>
              </template>
            </el-table-column>
            <el-table-column
                header-align="center"
                align="center"
                label="是否核销"
                prop="sendState"
                key="sendState"
            >
              <template slot-scope="scope">
                <div v-if="scope.row.prizeType==='1' || scope.row.prizeType==='2'">
                  <el-button type="text" size="small" disabled
                  >已发放</el-button
                  >
                </div>
                <div
                    v-else-if="scope.row.prizeType==='3' && scope.row.sendState === '未发放'"
                    style="color: #ff7f10"
                >
                  <el-button
                      type="text"
                      size="small"
                      @click="verification1(scope.row)"
                  >核销</el-button
                  >
                </div>
                <div v-else>
                  <el-button type="text" size="small" disabled
                  >已核销</el-button
                  >
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="hm-pagination">
            <el-pagination
                background
                :total="total"
                @size-change="handleSizeChangePart"
                @current-change="pagingPart"
                layout="total,sizes,  prev, pager, next, jumper"
                :current-page="currentPagePart"
            ></el-pagination>
          </div>
        </div>
      </div>
      <!-- <span
          slot="footer"
          class="dialog-footer flex flex-center"
          v-if="participateType1 === 'winning'"
      >
        <el-button
            size="small"
            type="primary"
            class="mr10"
            @click="manualOpen"
            style="background: #ff7f10; border-color: #ff7f10"
        >
          手动开奖</el-button
        >
        <el-popover
            placement="top-start"
            width="300"
            trigger="hover"
            content="重置后手机端恢复抽奖页面，可继续开奖."
        >
          <el-button slot="reference" @click="restLc" size="small" type="info">
            重置</el-button
          >
        </el-popover>
      </span> -->
    </el-dialog>
    <el-dialog :visible.sync="errValidGoods" width="30%" title="提示">
      <div class="errstyle">
        <div>
          您有
          <span class="error">{{ errInputResult.length }}</span
          >条数据有误
        </div>
        <div class="mb10" v-if="errInputResult.length">
          <div class="title">无效手机号</div>

          <el-table :data="errInputResult" border class="small-table">
            <el-table-column
                prop="mobile"
                header-align="center"
                align="center"
                label="无效手机号"
            ></el-table-column>
            <el-table-column
                prop="name"
                header-align="center"
                align="center"
                label="姓名"
            ></el-table-column>
          </el-table>
        </div>
        <div v-if="exist.length">
          <div class="title">已报名人员</div>
          <el-table :data="exist" border class="small-table">
            <el-table-column
                prop="mobile"
                header-align="center"
                align="center"
                label="手机号"
            ></el-table-column>
            <el-table-column
                prop="name"
                header-align="center"
                align="center"
                label="姓名"
            ></el-table-column>
          </el-table>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="请用微信扫一扫"
        :visible.sync="qrcodeDialogVisible"
        :modal="false"
        width="250px"
    >
      <div class="qrcode-wrapper">
        <img style="width:100%" :src="activityCode" alt="二维码" />
      </div>
       <div class="mt10 flex flex-center">
        <el-button @click='copyToClipboard(codePath)' type='primary' size='small'>复制链接</el-button>
      </div>
    </el-dialog>
    <el-dialog
        title="卡片二维码"
        :visible.sync="cardQrcodeVisible"
        :modal="false"
        width="60%"
    >
      <el-table
          stripe
          border
          ref="table"
          :data="cardChipInfoModelList"
          style="width: 100%"
          :span-method="objectSpanMethod"
          size="small"
      >
        <el-table-column
            type="index"
            label="序号"
            header-align="center"
            align="center"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="chipName"
            label="卡片名称"
        >
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="chipName"
            label="卡片图片"
        >
          <template slot-scope="scope">
            <img class="card-img" :src="scope.row.chipImg" alt="" srcset="" />
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="chipName"
            label="卡片二维码"
        >
          <template slot-scope="scope">
            <img :src="scope.row.qrcode" alt="" srcset="" />
          </template>
        </el-table-column>
        <el-table-column
            v-if="getCardMode === 'scan'"
            header-align="center"
            align="center"
            prop="chipName"
            label="公共二维码"
        >
          <template slot-scope="scope" v-if="scope.$index === 0">
            <img :src="commonQrcode" alt="" srcset="" />
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="参与活动记录"
        width="1200px"
        :visible.sync="dialogVisibleReservition"
        :before-close="handleClose"
    >
      <!-- <el-dialog
        width="800px"
        title="中奖记录"
        :visible.sync="innerVisible"
        append-to-body
      >
      <el-table
        :data="winningInfoList"
        style="width: 100%"
        stripe
        border
        max-height="500"
        size="small"
      >
      <el-table-column
        header-align="center"
        align="center"
        type="index"
        label="序号"
        width="50"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="参与会员手机号"
        prop="memberMobile"
        key="memberMobile"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="参与人姓名"
        prop="memberName"
        key="memberName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="奖品名称"
        prop="prizeName"
        key="prizeName"
      ></el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="是否发放"
        prop="sendState"
        key="sendState"
      >
      </el-table-column>
      <el-table-column
        header-align="center"
        align="center"
        label="发放人"
        prop="sendOperator"
        key="sendOperator"
      >
      </el-table-column>


      </el-table>


    </el-dialog> -->
      <div class="mb10 flex flex-between">
        <el-radio-group
            v-model="recordType"
            size="small"
            @change="recordTypeTab"
        >
          <el-radio-button label="participate">参与记录</el-radio-button>
          <el-radio-button label="winning">中奖记录</el-radio-button>
        </el-radio-group>
        <div>
          <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.memberName"
              placeholder="请输入参与者姓名"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.memberMobile"
              placeholder="请输入参与者手机号"
              size="small"
              class="ipt mr10"
          ></el-input>
          <!-- <el-select
        size="small"
        clearable
        class="mr10"
        placeholder="是否中奖"
        v-model="searchCondition.isDefaultWinner"
      >
        <el-option label="是" value="yes"> </el-option>
        <el-option label="否" value="no"> </el-option>
      </el-select> -->
          <el-button type="primary" size="small" @click="searchPart"
          >查询</el-button
          >
          <el-button
              type="success"
              size="small"
              @click="
              outputPart(
                'quertReservitionAllList',
                recordType === 'participate' ? '参与活动记录' : '活动中奖记录',
                'tablePart'
              )
            "
              :loading="isOutputing"
          >导出</el-button
          >
        </div>
      </div>
      <div>
        <el-table
            :data="participateList"
            style="width: 100%"
            stripe
            border
            max-height="500"
            ref="tablePart"
            size="small"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              key="joinId"
              :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="活动名称"
              prop="gameName"
              key="gameName"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :label="
              recordType === 'participate' ? '参与会员手机号' : '中奖会员手机号'
            "
              prop="memberMobile"
              key="memberMobile"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :label="recordType === 'participate' ? '参与人姓名' : '中奖人姓名'"
              prop="memberName"
              key="memberName"
          ></el-table-column>
          <!-- <el-table-column
        header-align="center"
        align="center"
        label="参与次数"
        prop="joinNum"
        key="joinNum"
      ></el-table-column> -->
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="参与时间"
              prop="joinTime"
              key="joinTime"
          >
          </el-table-column>
          <el-table-column
              v-else
              header-align="center"
              align="center"
              label="中奖时间"
              prop="winningTime"
              key="winningTime"
          >
          </el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="是否发放"
              prop="sendState"
              key="sendState"
          >
          </el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="奖品名称"
              prop="prizeName"
              key="prizeName"
          >
          </el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="核销码"
              prop="prizeType"
              key="prizeType"
          >
            <template slot-scope="scope">
              {{ scope.row.prizeType == 3 ?scope.row.redeemCode: '' }}
            </template>
          </el-table-column>
          <!-- <el-table-column
        header-align="center"
        align="center"
        label="是否中奖"
        prop="isWinner"
        key="isWinner"
      >
       <template slot-scope="scope">
        {{scope.row.isWinner?"已中奖":'未中奖'}}
      </template>
      </el-table-column> -->

          <!-- <el-table-column
        header-align="center"
        align="center"
        label="操作"
      >
      <template slot-scope="scope">
              <el-tooltip
          class="item"
          content="查看中奖记录"
          placement="top"
          v-if="scope.row.isWinner"
        >
          <button
            class="pointer mr10 no-bg"
            @click="winnerDetails(scope.row)"
          >
            <span class="hmicon icon-chakan blue"></span>
          </button>
        </el-tooltip>
      </template>

      </el-table-column> -->
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @size-change="handleSizeChangePart"
              @current-change="pagingPart"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePart"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="参与活动记录"
        width="1200px"
        :visible.sync="dialogVisibleReservition2"
        :before-close="handleClose2"
    >
      <div class="mb10 flex flex-between">
        <el-radio-group
            v-model="recordType"
            size="small"
            @change="recordTypeTab2"
        >
          <el-radio-button label="participate">参与记录</el-radio-button>
          <el-radio-button label="winning">中奖记录</el-radio-button>
        </el-radio-group>
        <div>
          <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.memberName"
              placeholder="请输入参与者姓名"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.memberMobile"
              placeholder="请输入参与者手机号"
              size="small"
              class="ipt mr10"
          ></el-input>
          <!-- <el-select
        size="small"
        clearable
        class="mr10"
        placeholder="是否中奖"
        v-model="searchCondition.isDefaultWinner"
      >
        <el-option label="是" value="yes"> </el-option>
        <el-option label="否" value="no"> </el-option>
      </el-select> -->
          <el-button type="primary" size="small" @click="searchPart"
          >查询</el-button
          >
          <el-button
              type="success"
              size="small"
              @click="
              outputPart(
                'quertRedEnvelopeRainAllList',
                recordType === 'participate' ? '参与活动记录' : '活动中奖记录',
                'tablePart'
              )
            "
              :loading="isOutputing"
          >导出</el-button
          >
        </div>
      </div>
      <div>
        <el-table
            :data="redEnvelopeRainList"
            style="width: 100%"
            stripe
            border
            max-height="500"
            ref="tablePart"
            size="small"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              key="joinId"
              :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :label="
              recordType === 'participate' ? '参与会员手机号' : '抽奖会员手机号'
            "
              prop="memberMobile"
              key="memberMobile"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              :label="recordType === 'participate' ? '参与会员姓名' : '抽奖会员姓名'"
              prop="memberName"
              key="memberName"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="参与时间"
              prop="joinTime"
              key="joinTime"
          >
          </el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="击中数量"
              prop="hitNum"
              key="hitNum"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="是否可参与抽奖"
              prop="drawState"
              key="drawState"
          >
            <template slot-scope="scope">
              <span class="success" v-if="scope.row.drawState==='yes'">是</span>
              <span class="danger" v-if="scope.row.drawState==='no'">否</span>
            </template>
          </el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="抽奖时间"
              prop="winningTime"
              key="winningTime"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="奖品"
              prop="prizeName"
              key="prizeName"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @size-change="handleSizeChangePart"
              @current-change="pagingPart"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePart"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="参与活动记录"
        width="1200px"
        :visible.sync="dialogVisibleReservition3"
        :before-close="handleClose3"
    >
      <div class="mb10 flex flex-between">
        <el-radio-group
            v-model="recordType"
            size="small"
            @change="recordTypeTab3"
        >
          <el-radio-button label="participate">参与记录</el-radio-button>
          <el-radio-button label="winning">中奖记录</el-radio-button>
        </el-radio-group>
        <div v-if="recordType === 'participate'">
          <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.inviteMemberName"
              placeholder="请输入客户名称"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-input
              clearable
              style="width: 250px"
              v-model.trim="searchCondition.employeeName"
              placeholder="请输入发送员工"
              size="small"
              class="ipt mr10"
          ></el-input>
          <el-select
              clearable
              class="mr10"
              size="small"
              v-model="searchCondition.taskState"
              placeholder="请选择任务状态"
          >
            <el-option label="已完成" value="yes"></el-option>
            <el-option label="未完成" value="no"></el-option>
          </el-select>
          <el-button type="primary" size="small" @click="searchPart"
          >查询</el-button
          >
          <!-- <el-button
              type="success"
              size="small"
              @click="
              outputPart(
                'quertRedEnvelopeRainAllList',
                recordType === 'participate' ? '参与活动记录' : '活动中奖记录',
                'tablePart'
              )
            "
              :loading="isOutputing"
          >导出</el-button
          > -->
        </div>
      </div>
      <div>
        <el-table
            :data="fissionRecordList"
            style="width: 100%"
            stripe
            border
            max-height="500"
            ref="tablePart"
            size="small"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              key="joinId"
              :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="客户"
              prop="inviteMemberName"
              key="inviteMemberName"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="发送员工"
              prop="employeeName"
              key="employeeName"
          >
          </el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="任务状态"
              prop="taskState"
              key="taskState"
          >
          </el-table-column>
          <el-table-column
              v-if="recordType === 'participate'"
              header-align="center"
              align="center"
              label="裂变好友数"
              prop="inviteCount"
              key="inviteCount"
          ></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" v-if="recordType === 'participate'">
            <template slot-scope="scope">
              <el-tooltip class="item" content="裂变好友明细" placement="top">
                <button
                    class="pointer mr10 no-bg"
                    @click="toFissionDetails(scope.row.memberId)"
                >
                  <span class="hmicon icon-chakan blue"></span>
                </button>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="客户"
              prop="memberName"
              key="memberName"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="手机号"
              prop="memberMobile"
              key="memberMobile"
          ></el-table-column>
          
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="奖品名称"
              prop="prizeName"
              key="prizeName"
          ></el-table-column>
          <el-table-column
              v-if="recordType === 'winning'"
              header-align="center"
              align="center"
              label="是否已发放"
              prop="sendState"
              key="sendState"
          ></el-table-column>          
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @size-change="handleSizeChangePart"
              @current-change="pagingPart"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePart"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        :close-on-click-modal="false"
        title="裂变好友列表"
        width="800px"
        :visible.sync="dialogVisibleReservition4"
        :before-close="handleClose4"
    >
      <div>
        <el-table
            :data="fissionRecordInviteList"
            style="width: 100%"
            stripe
            border
            max-height="500"
            ref="tablePart"
            size="small"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              key="joinId"
              :index="index => index + (currentPagePart - 1) * pageSizePart + 1"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="裂变新客户"
              prop="inviteMemberName"
              key="inviteMemberName"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="状态"
              prop="taskState"
              key="taskState"
          >
          </el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              label="添加时间"
              prop="createTime"
              key="createTime"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="total"
              @size-change="handleSizeChangePart"
              @current-change="pagingPart"
              layout="total,sizes,  prev, pager, next, jumper"
              :current-page="currentPagePart"
          ></el-pagination>
        </div>
      </div>
    </el-dialog>
    <el-dialog
        title="砍价活动明细"
        :visible.sync="kanjiaVisible"
        :close-on-click-modal="false"
        width="1000px"
    >
      <el-dialog
          width="1000px"
          title="砍价详情"
          :visible.sync="innerBargainVisible"
          append-to-body
      >
        <el-table
            :data="bargainDetailList"
            style="width: 100%"
            stripe
            border
            size="small"
            max-height="500"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
              index =>
                index +
                (currentBargainDetailPage - 1) * pageBargainDetailSize +
                1
            "
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="memberMobile"
              label="砍价人手机号"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="砍价人名称"
          ></el-table-column>

          <el-table-column
              header-align="center"
              align="center"
              prop="bargainMoney"
              label="砍价金额"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="joinTime"
              label="砍价时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="bargainDetailTotal"
              @current-change="bargainDetailPaging"
              @size-change="handleSizeBargainDetailChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="currentBargainDetailPage"
          ></el-pagination>
        </div>
      </el-dialog>
      <div class="flex flex-end mb10">
        <el-input
            clearable
            style="width: 250px"
            v-model.trim="memberMobile"
            placeholder="请输入手机号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="searchMemberMobile"
        >查询</el-button
        >
      </div>
      <el-table
          :data="bargainList"
          style="width: 100%"
          stripe
          border
          size="small"
          max-height="500"
      >
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
            index => index + (currentBargainPage - 1) * pageBargainSize + 1
          "
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="wxshopSpuName"
            label="商品名称"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="发起人姓名"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="发起人电话"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="payState"
            label="支付状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.payState === '1'" class="success">
              支付成功
            </div>
            <div v-if="scope.row.payState === '0'" class="gray">
              未支付
            </div>
            <div v-if="scope.row.payState === '9'" class="danger">
              支付失败
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="receiptSn"
            label="订单号"
        ></el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" content="查看" placement="top">
              <button
                  class="pointer mr10 no-bg"
                  @click="toBargainDetails(scope.row)"
              >
                <span class="hmicon icon-chakan blue"></span>
              </button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="bargainTotal"
            @current-change="bargainPaging"
            @size-change="handleSizeBargainChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentBargainPage"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
        title="砍价兑换明细"
        :visible.sync="exchangeRecordVisible"
        :close-on-click-modal="false"
        width="1000px"
    >
      <div class="flex flex-end mb10">
        <el-input
            clearable
            style="width: 250px"
            v-model.trim="exchangeRecord.memberMobile"
            placeholder="请输入手机号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-input
            clearable
            style="width: 250px"
            v-model.trim="exchangeRecord.orderSn"
            placeholder="请输入兑换单号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="searchExchangeRecord"
        >查询</el-button
        >
      </div>
      <el-table
          :data="exchangeRecordList"
          style="width: 100%"
          stripe
          border
          size="small"
          max-height="500"
      >
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
            index => index + (currentExchangeRecordPage - 1) * pageExchangeRecordSize + 1
          "
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="兑换人手机号"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="orderSnList"
            label="兑换订单号"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="exchangeTicketNum"
            label="兑换次数"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="exchangeTime"
            label="兑换时间"
        ></el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="exchangeRecordTotal"
            @current-change="exchangeRecordPaging"
            @size-change="handleSizeExchangeRecord"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="currentExchangeRecordPage"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog
        title="助力劵明细"
        :visible.sync="helping.helpingVisible"
        :close-on-click-modal="false"
        width="1000px"
    >
      <el-dialog
          width="1000px"
          title="助力详情"
          :visible.sync="helping.detail.helpingVisible"
          append-to-body
      >
        <el-table
            :data="helping.detail.list"
            style="width: 100%"
            stripe
            border
            size="small"
            max-height="500"
        >
          <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
              index =>
                index +
                (helping.detail.currentPage - 1) * helping.detail.pageSize +
                1
            "
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="memberMobile"
              label="助力人手机号"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="memberName"
              label="助力人姓名"
          ></el-table-column>
          <el-table-column
              header-align="center"
              align="center"
              prop="helpTime"
              label="助力时间"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="helping.detail.total"
              @current-change="helpingDetailPaging"
              @size-change="handleSizeHelpingDetailChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="helping.detail.currentPage"
          ></el-pagination>
        </div>
      </el-dialog>
      <div class="flex flex-end mb10">
        <el-select
            v-model="helping.joinState"
            placeholder="请选择状态"
            size="small"
            clearable
            class="mr10"
            style="width: 150px"
        >
          <el-option label="助力成功" value="success"></el-option>
          <el-option label="助力中" value="running"></el-option>
          <el-option label="助力失败" value="fail"></el-option>
        </el-select>
        <el-input
            clearable
            style="width: 250px"
            v-model.trim="helping.memberMobile"
            placeholder="请输入手机号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button type="primary" size="small" @click="helpingPaging(1)"
        >查询</el-button
        >
        <el-button type="success" @click="helpCouponOutput" size="small">导出</el-button>
      </div>
      <el-table
          :data="helping.list"
          style="width: 100%"
          stripe
          border
          size="small"
          max-height="500"
      >
        <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
            index => index + (helping.currentPage - 1) * helping.pageSize + 1
          "
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="name"
            label="优惠券名称"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="memberName"
            label="发起人姓名"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="memberMobile"
            label="发起人电话"
        ></el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="joinState"
            label="状态"
        >
          <template slot-scope="scope">
            <div v-if="scope.row.joinState == 'success'" class="success">
              助力成功
            </div>
            <div v-if="scope.row.joinState == 'running'" class="gray">
              助力中
            </div>
            <div v-if="scope.row.joinState == 'fail'" class="danger">
              助力失败
            </div>
          </template>
        </el-table-column>
        <el-table-column
            header-align="center"
            align="center"
            prop="receiptSn"
            label="已助力人数/需助力人数"
        >
          <template slot-scope="scope">
            {{scope.row.helpNum}}/{{scope.row.needHelpSum}}
          </template>
        </el-table-column>
        <el-table-column label="操作" header-align="center" align="center">
          <template slot-scope="scope">
            <el-tooltip class="item" content="查看" placement="top">
              <button
                  class="pointer mr10 no-bg"
                  @click="toHelpingDetails(scope.row)"
              >
                <span class="hmicon icon-chakan blue"></span>
              </button>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
            background
            :total="helping.total"
            @current-change="helpingPaging"
            @size-change="handleSizeHelpingChange"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="helping.currentPage"
        ></el-pagination>
      </div>
    </el-dialog>
    <el-dialog title="活动明细" :visible.sync="save_money_card_window" width="60%">
      <div class="flex flex-end">
        <el-select placeholder="请选择省钱卡名称" size="small" class="mr10" clearable v-model="conditionQuerySaveMoney.saveCardRuleId">
          <el-option
              v-for="(v,i) in saveMoneyCardName"
              :label="v.saveMoneyCardName"
              :value="v.id"
              :key="i"
          ></el-option>
        </el-select>
        <el-input  placeholder="请输入会员手机号/姓名" size="small"  class="mr10" clearable v-model="conditionQuerySaveMoney.keyWord"></el-input>
        <el-button size="small"  type="primary" @click="query_save_moneyCard">查询</el-button>
        <el-button size="small"  type="primary" @click="outPutSaveMoneyCard">导出</el-button>
      </div>
      <div style="margin-top: 20px;">
        <el-table
            align="center"
            :key="Math.random()"
            stripe
            :data="save_money_card_rowData"
        >
          <el-table-column
              align="cneter"
              label="序号"
              type="index"
              :index="
            index => index + (save_currentPage - 1) * save_pageSize + 1"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="memberMobile"
              label="会员手机号"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="memberName"
              label="会员姓名"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="saveMoneyCardName"
              label="省钱卡名称"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="cardTermEndTime"
              label="省钱卡有效期"
          ></el-table-column>
          <el-table-column
              align="center"
              label="剩余有效期"
          >
            <template slot-scope="scope">
              <span v-if="Math.floor((new Date(scope.row.cardTermEndTime)-new Date())/(1000*3600*24))>=0">{{Math.floor((new Date(scope.row.cardTermEndTime)-new Date())/(1000*3600*24))}}天</span>
              <span v-else>0天</span>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              prop="totalBalance"
              label="当前额度限额"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="availableBalance"
              label="当期额度余额"
          ></el-table-column>
          <el-table-column
              align="center"
              label="卡状态"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.cardStatus == 'frozen'" style="color: red">已冻结</span>
              <span v-if="scope.row.cardStatus == 'normal'" style="color: #2fc348">正常</span>
              <span v-if="scope.row.cardStatus == 'overdue'" style="color: #cccccc">已过期</span>
            </template>
          </el-table-column>
          <el-table-column
              align="center"
              label="操作"
          >
            <template slot-scope="scope">
              <el-button type="text" style="color: #2d8cf0" size="small" @click="freezeSaveMoneyCard(scope.row.id)" :disabled="scope.row.cardStatus == 'frozen' || scope.row.cardStatus == 'overdue'">冻结</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="save_total"
              @current-change="saveMoneyPaging"
              @size-change="saveMoneyChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="save_currentPage"
          ></el-pagination>
        </div>
        <div class="flex flex-center" style="margin-top: 30px;">
          <el-button size="small" @click="save_money_card_window = false" type="primary">关闭</el-button>
        </div>
      </div>
    </el-dialog>

    <el-dialog title="口令红包活动明细" :visible.sync="password_red_envelope_window" width="60%">
      <div class="flex flex-end">
        <!-- <el-input
            clearable
            style="width: 250px"
            v-model.trim="conditionQueryPassword.keyWord"
            placeholder="请输入参与者姓名"
            size="small"
            class="ipt mr10"
        ></el-input> -->
        <el-input
            clearable
            style="width: 250px"
            v-model.trim="conditionQueryPassword.mobile"
            placeholder="请输入参与者手机号"
            size="small"
            class="ipt mr10"
        ></el-input>
        <el-button size="small"  type="primary" @click="queryPasswordJoinList">查询</el-button>
        <el-button size="small"  type="primary" @click="outPutPasswordRedEnvelope">导出</el-button>
      </div>
      <div style="margin-top: 20px;">
        <el-table
            align="center"
            :key="Math.random()"
            stripe
            :data="password_red_envelope_rowData"
        >
          <el-table-column
              align="cneter"
              label="序号"
              type="index"
              :index="
            index => index + (password_currentPage - 1) * password_pageSize + 1"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="mobile"
              label="参与会员手机号"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="memberName"
              label="参与会员姓名"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="joinTime"
              label="参与时间"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="password"
              label="输入口令"
          ></el-table-column>
          <el-table-column
              align="center"
              prop="prize"
              label="获得奖励"
          ></el-table-column>
        </el-table>
        <div class="hm-pagination">
          <el-pagination
              background
              :total="password_total"
              @current-change="passwordPaging"
              @size-change="passwordChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="password_currentPage"
          ></el-pagination>
        </div>
        <div class="flex flex-center" style="margin-top: 30px;">
          <el-button size="small" @click="password_red_envelope_window = false" type="primary">关闭</el-button>
        </div>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmStatus from "@/components/HmStatus";
import { mapGetters } from "vuex";
import { getLoginUser,getUserName } from "@/utils/auth";
import { setCookie, getCookie, arrayUnique2 } from "@/utils/utils";
import XLSX from "xlsx";
import QRCode from "qrcode";
import moment from 'moment'

let wb; // 读取完成的数据
let rABS = false; // 是否将文件读取为二进制字符串
export default {
  components: {
    HmStatus
  },
  data() {
    return {
      validityDate:'',
      conditionQuerySaveMoney:{
        saveCardRuleId:'',
        keyWord:''
      },
      conditionQueryPassword:{
        name:"",
        mobile:"",
      },
      saveMoneyCardName:[],
      password_total:0,
      password_currentPage: 1,
      password_pageSize: 10,
      password_red_envelope_rowData:[],
      password_red_envelope_row:{},
      password_red_envelope_window:false,
      save_total:0,
      save_currentPage: 1,
      save_pageSize: 10,
      save_money_card_window:false,
      save_money_card_rowData:[],
      save_money_card_row: {},
      otherActivityWindow:false,
      bargainDetailTotal: 0,
      currentBargainDetailPage: 1,
      pageBargainDetailSize: 10,
      currentRows: {},
      bargainTotal: 0,
      currentBargainPage: 1,
      pageBargainSize: 10,
      bargainDetailList: [],
      innerBargainVisible: false,
      bargainList: [],
      kanjiaVisible: false,
      recordType: "participate",
      winningInfoList: [],
      dialogVisibleReservition: false,
      dialogVisibleReservition2: false,
      dialogVisibleReservition3: false,
      dialogVisibleReservition4: false,
      commonQrcode: "",
      cardChipInfoModelList: [],
      cardQrcodeVisible: false,
      ruleForm: {
        joinNumber: ""
      },
      rules: {
        joinNumber: [
          {
            required: true,
            message: "请输入中奖人数",
            trigger: "blur"
          },
          {
            required: true,
            pattern: /^[1-9]\d*$/,
            message: "请输入正整数",
            trigger: "blur"
          }
        ]
      },
      getCardMode: "",
      innerVisible: false,
      errValidGoods: false,
      errInputResult: [],
      exist: [],
      searchCondition: {},
      currentPagePart: 1,
      pageSizePart: 10,
      total: 0,
      participateList: [],
      redEnvelopeRainList: [],
      fissionRecordList: [],
      fissionRecordInviteList: [],
      participateType: "participate",
      participateType1:"participate",
      dialogVisible: false,
      dialogVisible1:false,
      dateFlag: "0",
      currentPage: 1,
      pageSize: 10,
      isOutputing: false,
      enabledState: "",
      gameType: "",
      keyword: "",
      checkedRow: [],
      visible: false,
      qrcodeDialogVisible: false,
      activityCode: "",
      storeCode: "",
      memberMobile: "",
      helping: {
        list: [],
        total: 0,
        helpingVisible: false,
        currentPage: 1,
        pageSize: 10,
        memberMobile: "",
        joinState: "",
        detail: {
          list: [],
          total: 0,
          helpingVisible: false,
          currentPage: 1,
          pageSize: 10
        }
      },
      helpingRow: {},
      exchangeRecordList:[],
      exchangeRecordTotal:0,
      exchangeRecordVisible:false,
      currentExchangeRecordPage:1,
      pageExchangeRecordSize:10,
      exchangeRecord:{},
      styleType:"",
      codePath:""
    };
  },
  computed: mapGetters(["myActivityList", "gameTypeList", "allGameTypeList"]),
  watch: {},
  created() {},
  mounted() {
    this.getParamsCookie();
    if (this.$route.query.gameType) {
      this.gameType = this.$route.query.gameType;
    }
    this.queryList();
    this.queryGameTypeList();
    const { storeCode } = getLoginUser();
    this.storeCode = storeCode;
  },
  methods: {
    outPutPasswordRedEnvelope(){  //导出省钱卡数据
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryPasswordJoinList()
            .then(() => {
              const list = this.password_red_envelope_rowData;

              const tHeader = [
                "参与会员手机号",
                "参与会员姓名",
                "参与时间",
                "输入口令",
                "获得奖励",
              ];
              const filterVal = [
                "mobile",
                "memberName",
                "joinTime",
                "password",
                "prize",
              ];
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(tHeader, data, "口令红包活动参与明细");
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    outPutSaveMoneyCard(){  //导出省钱卡数据
      require.ensure([], () => {
        const {
          exportJsonToExcel
        } = require("../../utils/output/Export2Excel");
        this.isOutputing = true;
        this.query_save_moneyCard()
            .then(() => {
              const list = this.save_money_card_rowData;

              list.forEach(function(item) {
                if (item.cardStatus == "frozen") {
                  item.cardStatus = "已冻结";
                } else if (item.cardStatus == "overdue") {
                  item.cardStatus = "已过期";
                } else if (item.cardStatus == "normal") {
                  item.cardStatus = "正常";
                }
                item.validityDate = Math.floor((new Date(item.cardTermEndTime)-new Date())/(1000*3600*24))+'天'
              });

              const tHeader = [
                "会员手机号",
                "会员姓名",
                "省钱卡名称",
                "省钱卡有效期",
                "剩余有效期",
                "当前额度限额",
                "当期额度余额",
                "卡状态",
              ];
              const filterVal = [
                "memberMobile",
                "memberName",
                "saveMoneyCardName",
                "cardTermEndTime",
                "validityDate",
                "totalBalance",
                "availableBalance",
                "cardStatus",
              ];
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(tHeader, data, "省钱卡活动参与明细");
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    async freezeSaveMoneyCard(row){  //冻结省钱卡
      await this.$store.dispatch("frozenMemberSaveMoneyCard",{
        id:row
      });
      this.$message({
        type: "success",
        message: "冻结成功！"
      });
      this.query_save_moneyCard();
    },
    async querySaveMoneyCardName(){   //查詢省钱卡名称
      let params = {
        gameId:this.save_money_card_row.gameId
      }
      const { result } = await this.$store.dispatch("querySaveMoneyCardRuleList",params);
      this.saveMoneyCardName = result;
    },
    async queryPasswordJoinList(){
      let params = {
        pageSize:this.password_pageSize,
        pageNo:this.password_currentPage,
        gameId:this.password_red_envelope_row.gameId
      }
      const conditionSearch = JSON.parse(JSON.stringify(this.conditionQueryPassword))
      Object.assign(params,conditionSearch);
      const { result } = await this.$store.dispatch("queryPasswordJoinList",params);
      this.password_red_envelope_rowData = result.records;
      this.password_total = result.total;
    },
    async query_save_moneyCard(){         //查询省钱卡活动明细
      let params = {
        pageSize:this.save_pageSize,
        pageNo:this.save_currentPage,
        gameId:this.save_money_card_row.gameId
      }
      const conditionSearch = JSON.parse(JSON.stringify(this.conditionQuerySaveMoney))
      Object.assign(params,conditionSearch);
      const { result } = await this.$store.dispatch("queryMemberSaveMoneyCardInfoList",params);
      this.save_money_card_rowData = result.records;
      this.save_total = result.total;
    },
    save_money_card(row){    //打开省钱卡活动明细窗口
      this.save_money_card_row = row;
      this.save_money_card_window = true;
      this.query_save_moneyCard();
      this.querySaveMoneyCardName();
    },
    password_red_envelope(row){
      this.password_red_envelope_row = row;
      this.password_red_envelope_window = true;
      this.queryPasswordJoinList();
    },
    //助力明细
    helpingDetail(row) {
      this.row = row;
      this.helping.memberMobile = "";
      //查询数据
      this.queryHelpingList();
    },
    //助力详情
    toHelpingDetails(row) {
      this.helpingRow = row;
      this.queryHelpingDetatilList();
    },
    //查询明细列表
    async queryHelpingList() {
      let params = {
        pageNo: this.helping.currentPage,
        pageSize: this.helping.pageSize,
        gameId: this.row.gameId,
        memberMobile: this.helping.memberMobile,
        joinState: this.helping.joinState
      };
      const { code, result } = await this.$store.dispatch(
          "queryHelpingRecordList",
          params
      );
      if (code === "0") {
        const { records, total } = result;
        this.helping.list = records;
        this.helping.total = total;
        this.helping.helpingVisible = true;
      }
    },
    //查询详情列表
    async queryHelpingDetatilList() {
      let params = {
        pageNo: this.helping.detail.currentPage,
        pageSize: this.helping.detail.pageSize,
        id: this.helpingRow.id
      };
      const { code, result } = await this.$store.dispatch(
          "queryHelpingDeatilRecordList",
          params
      );
      if (code === "0") {
        const { records, total } = result;
        this.helping.detail.list = records;
        this.helping.detail.total = total;
        this.helping.detail.helpingVisible = true;
      }
    },
    //助力明细分页
    helpingPaging(page) {
      this.helping.currentPage = page;
      this.queryHelpingList();
    },
    handleSizeHelpingChange(size) {
      this.helping.currentPage = 1;
      this.helping.pageSize = size;
      this.queryHelpingList();
    },
    //口令红包互动明细分页
    passwordPaging(page) {
      this.password_currentPage = page;
      this.queryPasswordJoinList();
    },
    passwordChange(size) {
      this.password_currentPage = 1;
      this.password_pageSize = size;
      this.queryPasswordJoinList();
    },
    //省钱卡互动明细分页
    saveMoneyPaging(page) {
      this.save_currentPage = page;
      this.query_save_moneyCard();
    },
    saveMoneyChange(size) {
      this.save_currentPage = 1;
      this.save_pageSize = size;
      this.query_save_moneyCard();
    },
    //助力详情分页
    helpingDetailPaging(page) {
      this.helping.detail.currentPage = page;
      this.queryHelpingDetatilList();
    },
    handleSizeHelpingDetailChange(size) {
      this.helping.detail.currentPage = 1;
      this.helping.detail.pageSize = size;
      this.queryHelpingDetatilList();
    },

    searchMemberMobile() {
      this.currentBargainPage = 1;
      this.queryBargainDetail();
    },
    searchExchangeRecord() {
      this.currentExchangeRecordPage = 1;
      this.queryExchangeRecordList();
    },
    recordTypeTab() {
      this.currentPagePart = 1;
      // this.pageSizePart = 10;
      this.quertReservitionList();
    },
    recordTypeTab2() {
      this.currentPagePart = 1;
      // this.pageSizePart = 10;
      this.queryRedEnvelopeRainJoinPageList();
    },
    recordTypeTab3() {
      this.currentPagePart = 1;
      // this.pageSizePart = 10;
      this.queryFissionRecord();
    },
    toReservitionList(row) {
      this.row = row;
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      this.quertReservitionList();
      this.dialogVisibleReservition = true;
    },
    toReservitionList2(row){
      this.row = row;
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      this.queryRedEnvelopeRainJoinPageList();
      this.dialogVisibleReservition2 = true;
    },
    toReservitionList3(row){
      this.row = row;
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      this.queryFissionRecord();
      this.dialogVisibleReservition3 = true;
    },
    toGetAwardsList(gameType, gameId) {
      this.$router.push({
        name: "WinningList",
        query: {
          gameType,
          gameId
        }
      });
    },
    objectSpanMethod({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 4) {
        return {
          colspan: 1,
          rowspan: this.cardChipInfoModelList.length
        };
      }
    },
    async viewCardCode(row) {
      const { result } = await this.$store.dispatch("queryCollectCardList", {
        gameId: row.gameId
      });
      if (result) {
        const { cardChipInfoModelList, getCardMode } = result;
        this.cardChipInfoModelList = cardChipInfoModelList;
        this.getCardMode = getCardMode;
        this.commonQrcode = await QRCode.toDataURL("common_" + row.gameId);
      }
      this.createCardQrcode();
    },
    createCardQrcode() {
      this.cardChipInfoModelList.forEach(async v => {
        v.qrcode = await QRCode.toDataURL(v.id);
      });
      this.$forceUpdate();
      this.cardQrcodeVisible = true;
    },
    async productQrcode(row) {
      console.log(row.gameId);
      let path = "";
      const { storeCode } = getLoginUser();
      let userName = getUserName();
      if (row.gameType === "lucky_charm") {
        let params = {
          path: `activity/luckyOne/luckyOne?gameId=${row.gameId}&gameShareContent=${row.gameShareContent}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "营销中心-我的活动-幸运转盘",
          shareFrom: "bg"
        }
        const url = await this.$store.dispatch("shareDataSaveV2", params);
        path = `activity/luckyOne/luckyOne?saveUUID=${url.result}`;
      } else if (row.gameType === "timed_draw") {
        path = `activity/timedDraw/timedDrawDetail?saveUUID=${row.gameId}`;
      } else if (row.gameType === "collect_card") {
        // const {result} = await this.$store.dispatch("shareDataSave", { url: path });
        path = "activity/collectCard/collectCard";
      } else if (row.gameType === "seckill") {
        path = "activity/seckill/seckill";
      } else if (
          row.gameType === "bargains_team" ||
          row.gameType === "lottery_team" ||
          row.gameType === "leader_free_team"
      ) {
        // path = "activity/groupBuying/group?type=bargains_team";
        let params = {
          path: `type=${row.gameType}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "营销中心-我的活动-拼团",
          shareFrom: "bg"
        }
        const url = await this.$store.dispatch("shareDataSaveV2", params);
        path = `activity/groupBuying/group?saveUUID=${url.result}`;
      }
          // else if (row.gameType === "lottery_team") {
          //   path = "activity/groupBuying/group?type=lottery_team";
          // } else if (row.gameType === "leader_free_team") {
          //   path = "activity/groupBuying/group?type=leader_free_team";
      // }
      else if (row.gameType === "bargain") {
        path = "activity/bargain/bargain";
      } else if (row.gameType === "turntable") {
        path = "activity/turnTable/turnTable";
      } else if (row.gameType === "integral_exchange") {
        // const newIntegralExchangeState = this.$route.query.newIntegralExchangeState
        path = "activity/integral/integralIndex?saveUUID="+row.gameId;
          // newIntegralExchangeState === "close"
          //   ? "activity/integral/integralIndex"
          //   : "activity/integral/integralIndexNew?saveUUID="+row.gameId;
      } else if (row.gameType === "single_single_exclusive") {
        let params = {
          path: `gameBgp=${row.gameBgp}&gameName=${row.gameName}&gameId=${row.gameId}&timeStatus=${row.timeStatus}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "营销中心-我的活动-单人专享",
          shareFrom: "bg"
        }
        const { result } = await this.$store.dispatch("shareDataSaveV2",params);
        path = `activity/single/singleActivityList?saveUUID=${result}`;
      } else if (row.gameType === "combination_set") {
        path = "activity/shopList/index";
      } else if (row.gameType === "help_coupon") {
        let params = {
          path: `activity/powerStamps/powerStamps?gameId=${row.gameId}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "营销中心-我的活动-助力券",
          shareFrom: "bg"
        }
        const url = await this.$store.dispatch("shareDataSaveV2", params);
        path = `activity/powerStamps/powerStamps?saveUUID=${url.result}`;
      } else if (row.gameType === "save_money_card") {
        let params = {
          path: `activity/saveMoney/saveMoney?gameId=${row.gameId}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "营销中心-我的活动-省钱卡",
          shareFrom: "bg"
        }
        const url = await this.$store.dispatch("shareDataSaveV2", params);
        path = `activity/saveMoney/saveMoney?saveUUID=${url.result}`;
      } else if (row.gameType === "password") {
        path = "activity/passwordRedEnvelope/passwordRedEnvelope";
      } else if (row.gameType === "red_envelope_rain") {
        path = "activity/redEnvelopeRain/redEnvelopeRain";
      } else if (row.gameType === "fission_person" || row.gameType === "fission_group"){
        let params = {
          path: `activity/fission/fission?gameId=${row.gameId}&gameType=${row.gameType}`,
          storeCode: storeCode,
          createBy: userName,
          shareFunction: "营销中心-我的活动-企微裂变",
          shareFrom: "bg"
        }
        const url = await this.$store.dispatch("shareDataSaveV2", params);
        path = `activity/fission/fission?saveUUID=${url.result}`;
      }
      // let path = `activity/luckyOne/luckyOneList?gameId=${
      //   row.gameId
      // }&dateFlag=${row.dateFlag}&gameShareContent=${row.gameShareContent}`;
      // if (row.gameType === "lucky_charm") {
      //   const url = await this.$store.dispatch("shareDataSaveV2", { url: path });

      //   path = `activity/luckyOne/luckyOne?saveUUID=${url.result}`;
      // }
      this.codePath = path
      const { result } = await this.$store.dispatch("createCouponQrcode", {
        path
      });
      this.qrcodeDialogVisible = true;
      this.activityCode = result;
    },
    async batchSetting(val) {
      if (this.checkedRow.length) {
        let params = {
          joinIdList: this.checkedRow,
          isDefaultWinner: val
        };
        const { code } = await this.$store.dispatch("changeIsWinner", params);
        if (code === "0") {
          this.$message({
            message: " 操作成功",
            type: "success"
          });
          this.visible = false;
          if (this.participateType === "participate") {
            this.queryPartList();
          } else {
            this.queryLuckyWinnerList();
          }
        }
      } else {
        this.$message({
          message: "请选择",
          type: "warning"
        });
      }
    },
    getChecked(selection) {
      this.checkedRow = selection.map(v => v.joinId);
    },
    async isDefaultWinnerChange(row) {
      let params = {
        joinIdList: [row.joinId],
        isDefaultWinner: row.isDefaultWinner
      };
      const { code } = await this.$store.dispatch("changeIsWinner", params);
      if (code === "0") {
        this.$message({
          message: " 操作成功",
          type: "success"
        });
        if (this.participateType === "participate") {
          this.queryPartList();
        } else {
          this.queryLuckyWinnerList();
        }
      }
    },
    verification(row) {
      this.$confirm("是否确定核销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
            .dispatch("luckyCharmWriteOff", { winningListId: row.winningListId })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryLuckyWinnerList();
              }
            });
      });
    },
    verification1(row) {
      this.$confirm("是否确定核销?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
            .dispatch("luckyCharmWriteOff", { winningListId: row.winningListId })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
                this.queryLuckyWinnerList1();
              }
            });
      });
    },
    resetRuleForm() {
      setTimeout(() => {
        this.$refs.ruleForm.resetFields();
      }, 0);
    },
    submitForm(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          let params = this.ruleForm;
          params.gameId = this.row.gameId;
          this.$store.dispatch("manualOpenPrize", params).then(res => {
            if (res.code === "0") {
              this.$message({
                message: "操作成功",
                type: "success"
              });
              this.innerVisible = false;
              this.queryLuckyWinnerList();
              this.resetRuleForm();
            }
          });
        } else {
          return false;
        }
      });
    },
    manualOpen() {
      this.innerVisible = true;
      this.resetRuleForm();
    },
    // 导出excel
    outputExcel() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        const tHeader = [
          "会员手机号(必填)",
          "姓名",
          "候选人身份（是/否）(必填)"
        ];
        const data = [];

        exportJsonToExcel(tHeader, data, "参与名单模板");
      });
    },
    // 导入excel
    importf(e) {
      const obj = e.target;
      const that = this;

      if (!obj.files) {
        return;
      }
      let f = obj.files[0];
      let reader = new FileReader();
      reader.onload = function(e) {
        let data = e.target.result;
        if (rABS) {
          wb = XLSX.read(btoa(this.fixdata(data)), {
            // 手动转化
            type: "base64"
          });
        } else {
          wb = XLSX.read(data, {
            type: "binary"
          });
        }
        let result = null;
        wb.SheetNames.forEach(sheetName => {
          let roa = XLSX.utils.sheet_to_json(wb.Sheets[sheetName], {
            header: 1
          });
          if (roa.length) {
            result = roa.slice(1);
          }
        });
        const formatResult = [];
        that.errInputResult = [];
        that.exist = [];
        let isRequired = true;
        result.forEach(v => {
          if (!v[0] || !v[2]) {
            isRequired = false;
          } else {
            // formatResult.push({
            //   mobile: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
            //   name: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
            //   isDefaultWinner: v[2] === "是" ? "yes" : "no"
            // });
            if (/^1[3-9]\d{9}$/.test(v[0])) {
              formatResult.push({
                mobile: v[0] ? (v[0] + "").replace(/\s*/g, "") : "",
                name: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
                isDefaultWinner: v[2] === "是" ? "yes" : "no"
              });
            } else {
              that.errInputResult.push({
                mobile: v[0],
                name: v[1] ? (v[1] + "").replace(/\s*/g, "") : "",
                isDefaultWinner: v[2] === "是" ? "yes" : "no"
              });
            }
          }
        });
        if (isRequired) {
          if (that.errInputResult.length) {
            that.errValidGoods = true;
          } else {
            let params = {
              gameId: that.row.gameId,
              joinList: arrayUnique2(formatResult, "mobile")
            };
            that.$store.dispatch("importJoinList", params).then(res => {
              that.errInputResult = res.result.fail;
              that.exist = res.result.exist;
              if (that.errInputResult.length > 0 || that.exist.length > 0) {
                that.errValidGoods = true;
              }
              that.queryPartList();
            });
          }
          // that.memberCount = formatResult.length;
        } else {
          if (!isRequired) {
            that.$message({
              message: "导入失败，请导入完整信息！",
              type: "warning"
            });
          }
        }
      };
      if (rABS) {
        reader.readAsArrayBuffer(f);
      } else {
        reader.readAsBinaryString(f);
      }
      obj.value = "";
    },
    pagingPart(page) {
      this.currentPagePart = page;
      if (this.dialogVisibleReservition) {
        this.quertReservitionList();
      } else if(this.dialogVisibleReservition2){
        this.queryRedEnvelopeRainJoinPageList();
      } else if(this.dialogVisibleReservition3){
        this.queryFissionRecord();
      } else {
        if (this.participateType === "participate") {
          this.queryPartList();
        } else {
          this.queryLuckyWinnerList();
        }
      }
    },
    handleSizeChangePart(size) {
      this.currentPagePart = 1;
      this.pageSizePart = size;
      if (this.dialogVisibleReservition) {
        this.quertReservitionList();
      } else if(this.dialogVisibleReservition2){
        this.queryRedEnvelopeRainJoinPageList();
      } else if(this.dialogVisibleReservition3){
        this.queryFissionRecord();
      }else {
        if (this.participateType === "participate") {
          this.queryPartList();
        } else {
          this.queryLuckyWinnerList();
        }
      }
    },
    searchPart() {
      this.currentPagePart = 1;
      if (this.dialogVisibleReservition) {
        this.quertReservitionList();
      } else if(this.dialogVisibleReservition2){
        this.queryRedEnvelopeRainJoinPageList();
      } else if(this.dialogVisibleReservition3){
        this.queryFissionRecord();
      } else {
        if (this.participateType === "participate") {
          this.queryPartList();
        } else {
          this.queryLuckyWinnerList();
        }
      }
    },
    searchPart1(){
        if (this.participateType1 === "participate") {
          this.queryPartList1();
        } else {
          this.queryLuckyWinnerList1();
        }
    },
    async queryPartList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryLuckyCharmlist",
          params
      );
      const { records, total } = result;
      this.participateList = records;
      this.total = total;
    },
    async queryPartList1() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId,
        ifOpenPrize:"no"
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryTimedCharmlist",
          params
      );
      const { joinList } = result;
      this.participateList = joinList.records;
      this.total = joinList.total;
    },
    async queryPartAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryLuckyCharmAlllist",
          params
      );
      const { records } = result;
      return records;
    },
    async queryPartAllList1() {
      let params = {
        pageNo: 1,
        pageSize: this.total,
        gameId: this.row.gameId,
        ifOpenPrize:"no"
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryTimedCharmlist",
          params
      );
      const { joinList } = result;
      this.participateList = joinList.records;
      this.total = joinList.total;
    },
    async queryLuckyWinnerList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryLuckyWinnerlist",
          params
      );

      const { records, total } = result;
      this.participateList = records;
      this.total = total;
    },
    async queryLuckyWinnerList1() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId,
        ifOpenPrize:"yes"
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryTimedCharmlist",
          params
      );
      console.log('result',result);
      const { joinList } = result;
      this.participateList = joinList.records;
      this.total = joinList.total;
    },
    async quertReservitionList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      let name =
          this.recordType === "participate"
              ? "queryTurntableLuckyDrawJoinList"
              : "queryTurntableLuckyDrawWinningList";

      const { result } = await this.$store.dispatch(name, params);

      const { records, total } = result;
      this.participateList = records;
      this.total = total;
    },
    async quertReservitionAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      let name =
          this.recordType === "participate"
              ? "queryTurntableLuckyDrawJoinAllList"
              : "queryTurntableLuckyDrawWinningAllList";

      const { result } = await this.$store.dispatch(name, params);

      const { records } = result;
      return records;
    },
    async queryRedEnvelopeRainJoinPageList() {
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      let name =
          this.recordType === "participate"
              ? "queryRedEnvelopeRainJoinPageList"
              : "queryRedEnvelopeRainWinningPageList";
      const { result } = await this.$store.dispatch(name, params);
      const { records, total } = result;
      this.redEnvelopeRainList = records;
      this.total = total;
    },
    async queryFissionRecord(){
      console.log("this.row:",this.row);
      let fissionType;
      if(this.row.gameType === 'fission_group'){
        fissionType = 1;
      }else{
        fissionType = 0;
      }
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId,
        fissionType,
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      let name =
          this.recordType === "participate"
              ? "fissionRecord"
              : "queryTurntableLuckyDrawWinningList";
      const { result } = await this.$store.dispatch(name, params);
      const { records, total } = result;
      if(this.recordType === "participate"){
        this.fissionRecordList = records;
      }else{
        this.fissionRecordList = records;
      }
      this.total = total;
    },
    async quertRedEnvelopeRainAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      let name =
          this.recordType === "participate"
              ? "queryRedEnvelopeRainJoinPageList"
              : "queryRedEnvelopeRainWinningPageList";

      const { result } = await this.$store.dispatch(name, params);

      const { records } = result;
      return records;
    },
    async queryLuckyWinnerAllList() {
      let params = {
        pageNo: 1,
        pageSize: 99999,
        gameId: this.row.gameId
      };
      let searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { result } = await this.$store.dispatch(
          "queryLuckyWinnerAlllist",
          params
      );
      const { records } = result;
      return records;
    },
    handleClose() {
      this.dialogVisible = false;
      this.dialogVisibleReservition = false;
      this.searchCondition = {};
    },
    handleClose2() {
      this.dialogVisible = false;
      this.dialogVisibleReservition2 = false;
      this.searchCondition = {};
    },
    handleClose3() {
      this.dialogVisible = false;
      this.dialogVisibleReservition3 = false;
      this.searchCondition = {};
    },
    handleClose4() {
      this.dialogVisibleReservition4 = false;
    },
    handleClose5() {
      this.dialogVisible1 = false;
      this.searchCondition = {};
    },
    switchTabPar(val) {
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      if (val === "participate") {
        this.queryPartList();
      } else {
        this.queryLuckyWinnerList();
      }
    },
    switchTabPar1(val) {
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      if (val === "participate") {
        this.queryPartList1();
      } else {
        this.queryLuckyWinnerList1();
      }
    },
    queryGameTypeList() {
      return this.$store.dispatch("queryGameTypeList");
    },
    queryAllList() {
      return this.$store.dispatch("queryAllMyActivityList", {
        pageNo: 1,
        pageSize: 99999
      });
    },
    queryList() {
      this.setParamsCookie();
      return this.$store.dispatch("queryMyActivityList", {
        pageNo: this.currentPage,
        pageSize: this.pageSize,
        dateFlag: this.dateFlag,
        enabledState: this.enabledState,
        gameType: this.gameType,
        keyWords: this.keyword
      });
    },
    setParamsCookie() {
      let searchCondition = {
        dateFlag: this.dateFlag,
        enabledState: this.enabledState,
        gameType: this.gameType,
        keyword: this.keyword
      };
      setCookie({
        key: "myActivityParams",
        type: "session",
        data: Object.assign({}, searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({ key: "myActivityParams", type: "session" });
      if (prams) {
        this.dateFlag = prams.dateFlag;
        this.enabledState = prams.enabledState;
        this.keyword = prams.keyword;
        this.gameType = prams.gameType;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    outputPart(funcName, title, table) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        func(this.currentRow)
            .then(res => {
              const list = res;
              if (this.participateType === "participate") {
                list.forEach(v => {
                  v.isDefaultWinner = v.isDefaultWinner === "yes" ? "是" : "否";
                  v.memberInfo = v.memberName + "/" + v.memberMobile;
                  v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
                });
              } else {
                list.forEach(v => {
                  v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
                  v.winningType =
                      v.winningType === "manual" ? "手动开奖" : "自动开奖";
                  v.memberInfo = v.memberName + "/" + v.memberMobile;
                });
              }

              const tHeader = this.$refs[table].columns
                  .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
                  .filter(o => o);
              let isHaveMemberHelpValue = false;
              tHeader.forEach(v => {
                if (v.includes("个人助力值")) {
                  isHaveMemberHelpValue = true;                
                }
              });
              let filterVal = [];
              if(this.participateType === "winning" && isHaveMemberHelpValue){
                filterVal = [
                  "gameName",
                  "createTime",
                  "joinType",
                  "memberInfo",
                  "memberHelpValue",
                  "winningType",
                  "sendState",
                ];                
              }else{
                if (list.length > 0) {
                  filterVal = this.$refs[table].$children
                      .map(o => o._props.prop)
                      .filter(o => o);
                }
              }
              console.log("list:",list);
              const data = this.formatJson(filterVal, list);
              console.log("tHeader:",tHeader);
              console.log("data2:",data);
              exportJsonToExcel(
                  tHeader,
                  data,
                  title + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    outputPart1(funcName, title, table) {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        const func = this[funcName];
        console.log('this.func',func);
        console.log('this.func',this.currentRow);
        func(this.currentRow)
            .then(res => {
              const list = this.participateList;
              if (this.participateType1 === "participate") {
                list.forEach(v => {
                  v.memberInfo = v.memberName + "/" + v.memberMobile;
                  v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
                });
              } else {
                list.forEach(v => {
                  v.joinType = v.joinType === "import" ? "导表参加" : "报名参加";
                  v.memberInfo = v.memberName + "/" + v.memberMobile;
                });
              }

              const tHeader = this.$refs[table].columns
                  .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
                  .filter(o => o);
              let filterVal = [];
              if(this.participateType1 === "winning"){
                filterVal = [
                  "gameName",
                  "winningTime",
                  "joinType",
                  "memberInfo",
                  "winningType",
                  "sendState"
                ];                
              }else{
                if (list.length > 0) {
                  filterVal = this.$refs[table].$children
                      .map(o => o._props.prop)
                      .filter(o => o);
                }
              }
              console.log("list:",list);
              const data = this.formatJson(filterVal, list);
              console.log("tHeader:",tHeader);
              console.log("data2:",data);
              exportJsonToExcel(
                  tHeader,
                  data,
                  title + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;
        this.queryAllList()
            .then(() => {
              const list = this.myActivityList.pageList.records;
              list.forEach(v => {
                if (v.enabledState == "yes") {
                  v.enabledState = "上线";
                } else {
                  v.enabledState = "下线";
                }
                if (v.gameType === "turntable") {
                  v.gameType = "大转盘";
                } else if (v.gameType === "bargain") {
                  v.gameType = "砍价";
                } else if (v.gameType === "seckill") {
                  v.gameType = "秒杀";
                } else if (v.gameType === "bargains_team") {
                  v.gameType = "特价团";
                } else if (v.gameType === "lottery_team") {
                  v.gameType = "抽奖团";
                } else if (v.gameType === "leader_free_team") {
                  v.gameType = "团长免单团";
                } else if (v.gameType === "integral_exchange") {
                  v.gameType = "积分兑换";
                } else if (v.gameType === "single_single_exclusive") {
                  v.gameType = "单人单次专享活动";
                } else if (v.gameType === "lucky_charm") {
                  v.gameType = "锦鲤活动";
                } else if (v.gameType === "help_coupon") {
                  v.gameType = "助力劵活动";
                } else if (v.gameType === "save_money_card") {
                  v.gameType = "省钱卡";
                } else if (v.gameType === "password") {
                  v.gameType = "口令红包";
                } else if (v.gameType === "red_envelope_rain") {
                  v.gameType = "红包雨";
                } else if (v.gameType === "timed_draw") {
                  v.gameType = "定时抽奖";
                }
              });

              const tHeader = [
                "活动编号",
                "活动类型",
                "活动名称",
                "活动创建时间",
                "活动状态"
              ];
              const filterVal = [
                "gameCode",
                "gameType",
                "gameName",
                "createTime",
                "enabledState"
              ];
              const data = this.formatJson(filterVal, list);
              exportJsonToExcel(
                  tHeader,
                  data,
                  "我的活动" + new Date().toLocaleString()
              );
              this.isOutputing = false;
            })
            .catch(() => {
              this.isOutputing = false;
            });
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    restLc() {
      this.$confirm("是否确定重置?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.$store
            .dispatch("luckyCharmReset", { gameId: this.row.gameId })
            .then(res => {
              if (res.code === "0") {
                this.$message({
                  message: " 操作成功",
                  type: "success"
                });
              }
            });
      });
    },
    reset() {
      this.enabledState = "";
      this.gameType = "";
      this.keyword = "";
    },
    switchTab() {
      this.currentPage = 1;
      this.queryList();
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    xiaxian(row) {
      this.$store
          .dispatch("updateEnabled", {
            gameId: row.gameId,
            enabledState: "no"
          })
          .then(res => {
            if (res.code === "0") {
              this.queryList();
            }
          });
    },
    shangxian(row) {
      this.$store
          .dispatch("updateEnabled", {
            gameId: row.gameId,
            enabledState: "yes"
          })
          .then(res => {
            if (res.code === "0") {
              this.queryList();
            }
          });
    },
    copy(row) {
      if (row.gameType === "turntable") {
        this.$router.push({
          name: "WheelAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            wheelType: row.uiType
          }
        });
      } else if (row.gameType === "seckill") {
        this.$router.push({
          name: "SeckillAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "bargain") {
        this.$router.push({
          name: "BargainAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "bargains_team") {
        this.$router.push({
          name: "SpecialAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "lottery_team") {
        this.$router.push({
          name: "LotteryAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "leader_free_team") {
        this.$router.push({
          name: "LeaderFreeAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "integral_exchange") {
        this.$router.push({
          name: "Redeem",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "single_single_exclusive") {
        this.$router.push({
          name: "Single",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "lucky_charm") {
        this.$router.push({
          name: "LuckyCharm",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "collect_card") {
        this.$router.push({
          name: "AddCollectCardAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "combination_set") {
        this.$router.push({
          name: "AddPlanActivities",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "help_coupon") {
        this.$router.push({
          name: "AddHelpingAct",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "save_money_card") {
        this.$router.push({
          name: "AddSaveMoneyOnCard",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      }else if (row.gameType === "password") {
        this.$router.push({
          name: "AddPasswordRedEnvelope",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      }else if (row.gameType === "red_envelope_rain") {
        this.$router.push({
          name: "AddRedEnvelopeRain",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "fission_person" || row.gameType === "fission_group") {
        this.$router.push({
          name: "Fission",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      } else if (row.gameType === "timed_draw") {
        this.$router.push({
          name: "TimedDraw",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "copy"
          }
        });
      }
    },

    async queryActivitDetail(row){
      this.row = row;
      const { result } = await this.$store.dispatch("queryActivitDetail", {
        gameId: row.gameId
      });
      this.styleType = result.luckyCharmRuleModel.styleType;
      console.log("styleType",this.styleType);
    },
    async participate(row) {
      this.row = row;
      this.queryActivitDetail(row).then(()=>{
        this.dialogVisible = true;
        this.participateType = "participate";
        this.currentPagePart = 1;
        this.pageSizePart = 10;
        if (this.participateType === "participate") {
          this.queryPartList();
        } else {
          this.queryLuckyWinnerList();
        }
      })
    },
    async participate1(row) {
      this.row = row;
      // const { result } = await this.$store.dispatch("queryActivitDetail", {
      //   gameId: row.gameId
      // });
      this.dialogVisible1 = true;
      this.participateType1 = "participate";
      this.currentPagePart = 1;
      this.pageSizePart = 10;
      if (this.participateType1 === "participate") {
        this.queryPartList1();
      } else {
        this.queryLuckyWinnerList1();
      }
    },
    async winnerDetails() {
      // this.innerVisible = true;
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId
      };
      const { code, result } = await this.$store.dispatch(
          "queryTurntableLuckyDrawWinningList",
          params
      );
      if (code === "0") {
        const { records, total } = result;
        this.participateList = records;
        this.total = total;
      }
    },
    toDetails(row) {
      if (row.gameType === "turntable") {
        this.$router.push({
          name: "DetailsWheelAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "seckill") {
        this.$router.push({
          name: "DetailsSeckillAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "bargain") {
        this.$router.push({
          name: "DetailsBargainAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "lottery_team") {
        this.$router.push({
          name: "DetailsLotteryAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "bargains_team") {
        this.$router.push({
          name: "DetailsSpecialAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "leader_free_team") {
        this.$router.push({
          name: "DetailsLeaderFree",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "integral_exchange") {
        this.$router.push({
          name: "Redeem",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      } else if (row.gameType === "single_single_exclusive") {
        this.$router.push({
          name: "Single",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      } else if (row.gameType === "lucky_charm") {
        this.$router.push({
          name: "LuckyCharm",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      } else if (row.gameType === "combination_set") {
        this.$router.push({
          name: "AddPlanActivities",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      } else if (row.gameType === "help_coupon") {
        this.$router.push({
          name: "HelpCouponActDetail",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      }else if (row.gameType === "save_money_card") {
        this.$router.push({
          name: "SaveMoneyCarDetail",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      }else if (row.gameType === "password") {
        this.$router.push({
          name: "PasswordRedEnvelopeDetail",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      }else if (row.gameType === "red_envelope_rain") {
        this.$router.push({
          name: "DetailsRedEnvelopeRain",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      }else if (row.gameType === "fission_person" || row.gameType === "fission_group") {
        this.$router.push({
          name: "Fission",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      } else if (row.gameType === "timed_draw") {
        this.$router.push({
          name: "TimedDraw",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "details"
          }
        });
      }
    },
    toBargainDetails(row) {
      this.currentRows = row;
      this.queryBargainOrderDetail();
    },
    exchangeDetail(row){
      this.row = row;
      this.queryExchangeRecordList();
    },
    async queryExchangeRecordList(){
      let params = {
        pageNo: this.currentBargainPage,
        pageSize: this.pageBargainSize,
        gameId: this.row.gameId,
        memberMobile: this.exchangeRecord.memberMobile,
        orderSn:this.exchangeRecord.orderSn,
      };
      const { code, result } = await this.$store.dispatch(
          "queryExchangeRecordList",
          params
      );
      if (code === "0") {
        const { records, total } = result;
        this.exchangeRecordList = records;
        this.exchangeRecordTotal = total;
        this.exchangeRecordVisible = true;
      }
    },
    bargainDetail(row) {
      this.row = row;
      this.queryBargainDetail();
    },
    async queryBargainDetail() {
      let params = {
        pageNo: this.currentBargainPage,
        pageSize: this.pageBargainSize,
        gameId: this.row.gameId,
        memberMobile: this.memberMobile
      };
      const { code, result } = await this.$store.dispatch(
          "queryBargainDetail",
          params
      );
      if (code === "0") {
        const { records, total } = result;
        this.bargainList = records;
        this.bargainTotal = total;
        this.kanjiaVisible = true;
      }
    },
    async queryBargainOrderDetail() {
      let params = {
        pageNo: this.currentBargainDetailPage,
        pageSize: this.pageBargainDetailSize,
        parentJoinId: this.currentRows.parentJoinId,
        gameId: this.row.gameId
      };
      const { code, result } = await this.$store.dispatch(
          "queryBargainOrderDetail",
          params
      );
      if (code === "0") {
        const { records, total } = result;
        this.bargainDetailList = records;
        this.bargainDetailTotal = total;
        this.innerBargainVisible = true;
      }
    },
    bargainDetailPaging(page) {
      this.currentBargainDetailPage = page;
      this.queryBargainOrderDetail();
    },
    handleSizeBargainDetailChange(size) {
      this.currentBargainDetailPage = 1;
      this.pageBargainDetailSize = size;
      this.queryBargainOrderDetail();
    },
    bargainPaging(page) {
      this.currentBargainPage = page;
      this.queryBargainDetail();
    },
    handleSizeBargainChange(size) {
      this.currentBargainPage = 1;
      this.pageBargainSize = size;
      this.queryBargainDetail();
    },
    exchangeRecordPaging(page) {
      this.currentExchangeRecordPage = page;
      this.queryExchangeRecordList();
    },
    handleSizeExchangeRecord(size){
      this.currentExchangeRecordPage = 1;
      this.pageExchangeRecordSize = size;
      this.queryExchangeRecordList();
    },
    edit(row) {
      console.log('row',row);
      if (row.gameType === "turntable") {
        this.$router.push({
          name: "EditWheelAct",
          query: {
            type: false,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "seckill") {
        this.$router.push({
          name: "EditSeckillAct",
          query: {
            type: false,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "bargain") {
        this.$router.push({
          name: "EditBargainAct",
          query: {
            type: false,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "bargains_team") {
        this.$router.push({
          name: "EditSpecialAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "lottery_team") {
        this.$router.push({
          name: "EditLotteryAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "leader_free_team") {
        this.$router.push({
          name: "EditLeaderFreeAct",
          query: {
            type: true,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "integral_exchange") {
        this.$router.push({
          name: "Redeem",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "single_single_exclusive") {
        this.$router.push({
          name: "Single",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "lucky_charm") {
        this.$router.push({
          name: "LuckyCharm",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "combination_set") {
        this.$router.push({
          name: "AddPlanActivities",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "help_coupon") {
        this.$router.push({
          name: "HelpCouponActDetail",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "save_money_card") {
        this.$router.push({
          name: "SaveMoneyCarDetail",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "password") {
        this.$router.push({
          name: "PasswordRedEnvelopeDetail",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "red_envelope_rain") {
        this.$router.push({
          name: "EditRedEnvelopeRain",
          query: {
            type: false,
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      } else if (row.gameType === "fission_person" || row.gameType === "fission_group") {
        this.$router.push({
          name: "Fission",
          query: {
            gameType: row.gameType,
            gameId: row.gameId,
            type: "edit"
          }
        });
      } else if (row.gameType === "timed_draw") {
        this.$router.push({
          name: "TimedDraw",
          query: {
            type: 'edit',
            gameType: row.gameType,
            gameId: row.gameId
          }
        });
      }
    },
    otherActivity(){
      console.log(this.gameType);
      if(this.gameType == "otherGame"){
        this.otherActivityWindow = true;
      }
    },
    clearSelect(){
      this.gameType = this.$route.query.gameType;
    },
    skip(url){
      this.$router.push({name:url})
      this.otherActivityWindow = false;
    },
    async toFissionDetails(inviteMemberId){
      let fissionType;
      if(this.row.gameType === 'fission_group'){
        fissionType = 1;
      }else{
        fissionType = 0;
      }
      let params = {
        pageNo: this.currentPagePart,
        pageSize: this.pageSizePart,
        gameId: this.row.gameId,
        fissionType,
        inviteMemberId
      };
      const { result } = await this.$store.dispatch('fissionRecordInvite', params);
      const { records, total } = result;
      this.fissionRecordInviteList = records;
      this.total = total;
      this.dialogVisibleReservition4 = true;
    },
  
     async copyToClipboard(text) {
      // 将saveUUID参数名替换为scene
      let processedText = '/' + text;
      if (processedText.includes('saveUUID=')) {
        const url = new URL(processedText, window.location.origin);
        const saveUUID = url.searchParams.get('saveUUID');
        if (saveUUID) {
          url.searchParams.delete('saveUUID');
          url.searchParams.set('scene', saveUUID);
          processedText = url.pathname + url.search;
        }
      }
      
      try {
        await navigator.clipboard.writeText(processedText);
        this.$message.success("复制成功");
      } catch (err) {
        try {
          await this.fallbackCopy(processedText);
        } catch (fallbackErr) {
          this.$message.error("复制失败，请手动复制");
          console.error('复制失败:', fallbackErr);
        }
      }
    },
    // 备用复制方法-用户浏览器不支持clipboard.writeText()
    fallbackCopy(text) {
      return new Promise((resolve, reject) => {
        try {
          const textarea = document.createElement('textarea');
          textarea.style.position = 'fixed';
          textarea.style.opacity = 0;
          textarea.style.left = '-999999px';
          textarea.style.top = '-999999px';
          textarea.value = text;
          document.body.appendChild(textarea);
          textarea.select();
          
          const success = document.execCommand('copy');
          document.body.removeChild(textarea);
          
          if (success) {
            console.log('使用备用方法复制文本');
            this.$message.success("复制成功");
            resolve();
          } else {
            this.$message.error("复制失败");
            reject(new Error('Fallback copy failed'));
          }
        } catch (err) {
          console.error('备用复制方法出错:', err);
          this.$message.error("复制失败");
          reject(err);
        }
      });
    },
    async helpCouponOutput() {
      // 助力券明细导出
       let params = {
        pageNo: this.helping.currentPage,
        pageSize: this.helping.pageSize,
        gameId: this.row.gameId,
        memberMobile: this.helping.memberMobile,
        joinState: this.helping.joinState
      };
      await this.$store.dispatch("helpCouponExport", params);
      setTimeout(() => {
        this.$message({
          message: "已加入导出队列正在生成报表，请在导出列队中查看！",
          type: "success"
        });
        this.$refs.hmcontent.flag = false;
      }, 0);
    },
  }
};
</script>
<style lang="scss" scoped>
.open-file {
  position: relative;
  overflow: hidden;
}
.open-file input {
  position: absolute;
  font-size: 100px;
  right: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
}
.status {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  margin-right: 10px;
  margin-top: -2px;
}
.errstyle {
  .title {
    margin-bottom: 10px;
    &::before {
      display: inline-block;
      margin-right: 5px;
      content: "";
      width: 4px;
      height: 12px;
      background: #e50065;
      border-top-left-radius: 30px;
      border-bottom-right-radius: 30px;
    }
  }
}
.card-img {
  width: 100px;
}
</style>
